export default __webpack_public_path__ + "static/media/dropbox-logo.55ad5002.svg";